import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Page } from '../../components/Page';
import {
  Accordion, AccordionItem, Row, Column,
  Form, FormGroup, Toggle, Layer, FormLabel, Button, Loading,
} from '@carbon/react';
//import { accordion_inner } from './SettingsPage.module.scss';

import { featuresActions } from '../../redux/actions';

import './_settings.scss';
import { BundesligaSettings } from './Features/Bundesliga';
import { WM2022Settings } from './Features/wm2022';
import { RadioSettings } from './Features/Radio';
import {
  Panel,
  PanelFooter,
  PanelHeader,
  PanelLabel,
} from '../../components/Panel';

import { useGetAdminFeaturesQuery } from 'services/features';
import { SelectableGroups } from '@/components/GroupsSelection/Groups';
import { useUpdateAdminFeaturesMutation } from '@/redux/new_services/features';
import { showToast } from '@/redux/new_services/toasts';
import { parseFeatureSettings } from '@/lib/featureSettings';

export const Settings = () => {

  const dispatch = useDispatch();
  const [settings, setSettings] = useState([]);
  const { data: features, isLoading } = useGetAdminFeaturesQuery();
  const [update, {isLoading: isSaving}] = useUpdateAdminFeaturesMutation();

  useEffect(() => {
    if (features) {
      let all_features = features.map(f => ({...f, settings: parseFeatureSettings(f.settings)}));

      setSettings(all_features);
    }
  }, [features]);


  const handleSaveFeatureSettings = (settings) => {
    //dispatch(featuresActions.update(settings));
    console.info("handleSaveFeatureSettings:", settings);
    try {
      update({id: settings.model.ID, feature: {...settings, groups: (settings.groups || []).map(g => g?.model?.ID || g)}}).unwrap();
      dispatch(showToast({kind: 'success', title: 'Features', subtitle: `Änderungen an ${settings.description} wurde erfolgreich gespeichert.`}))
    } catch (e) {
      console.error("Error saving settings", e);
    }
  };
  const handleSaveAllgemein = (id) => {
    //dispatch(featuresActions.update(settings));
    console.info("handleSaveAllgemeinSettings:", settings);
    try {
      const setting = settings[id - 1];
      update({id: setting.model.ID, feature: {...setting, groups: (setting.groups || []).map(g => g?.model?.ID || g)}}).unwrap();
      dispatch(showToast({kind: 'success', title: 'Features', subtitle: `Änderungen an ${setting.description} wurde erfolgreich gespeichert.`}))
    } catch (e) {
      console.error("Error saving settings", e);
    }

    console.info("handleSaveAllgemein:", settings[id - 1]);
  }

  const handleChangeGroups = (id, groups) => {
    console.info("handleChangeGroups triggered", id, groups);
    setSettings(prev => {
      return prev.map(item => {
        if (item.model.ID === id) {
          return {...item, groups: groups};
        }
        return item;
      });
    })
  }

  const changeEnableStateForFeature = (name, enabled) => {
    setSettings(prev => {
      return prev.map(item => {
        if (item.name === name) {
          return {...item, enabled};
        }
        return item;
      });
    })
  }

  useEffect(() => {
    console.info("Settings:",settings);
  },[settings])

  return (
    <Page pageTitle="Features bearbeiten" hasSideNav isLoading={isLoading}>
      <Loading active={isSaving} />
      <Row>
        <Column md={5}>
          <Row className="small_row">
            <Column md={4}>
              <Panel small>
                <PanelHeader header>
                  Wichtig!
                </PanelHeader>
                <PanelLabel>
                  Achtung, Einstellungen die hier verändert werden haben
                  sofortige auswirkung für alle Systeme und Benutzer!
                </PanelLabel>

                <PanelFooter></PanelFooter>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
      <Row>
        <Column>
          <Accordion align="start">
            {settings.map((item, key) => (
              <AccordionItem title={item.description} key={`${key}_feature_accordion`}>
                <Layer>
                  <Form>
                    <FormGroup legendText="Allgemein">
                      <FormLabel>Feature Status</FormLabel>
                      <br/>
                      <Toggle
                        id={`${key}_field_for_enable_feature`}
                        labelB="Aktiviert"
                        labelA="Deaktiviert"
                        labelText=""
                        toggled={item.enabled}
                        onToggle={() => changeEnableStateForFeature(item.name, !item.enabled)}
                      />
                      <br/>
                      <FormLabel>Gruppenzuordnung</FormLabel>
                      <SelectableGroups selection={(item.groups || []).map(g => g?.model?.ID || g)} onSelectionChange={(groups) => handleChangeGroups(item.model.ID,groups)} />
                      <br/>
                      <Button
                        size="md"
                        kind="secondary"
                        onClick={() => {handleSaveAllgemein(item.model.ID)}}
                      >Speichern</Button>
                    </FormGroup>
                  </Form>
                  <br/>
                  {item.name === 'bl' && <BundesligaSettings item={item} onSave={handleSaveFeatureSettings} />}
                  {item.name === 'stream' && <RadioSettings item={item} onSave={handleSaveFeatureSettings} />}
                </Layer>
              </AccordionItem>
            ))}

          </Accordion>
        </Column>
      </Row>
    </Page>
  );
};

/*
<AccordionItem title="Feature - WM2022">
  <WM2022Settings item={radioitem} onSave={handleSaveFeatureSettings} />
</AccordionItem>
*/
